export enum RadioDateFilterOperation {
  IS_EXACTLY_DAYS_AGO = 'IS_EXACTLY_DAYS_AGO',
  IS_MORE_THAN_DAYS_AGO = 'IS_MORE_THAN_DAYS_AGO',
  IS_LESS_THAN_DAYS_AGO = 'IS_LESS_THAN_DAYS_AGO',
  IS_ON = 'IS_ON',
  IS_AFTER = 'IS_AFTER',
  IS_BEFORE = 'IS_BEFORE',
  IS_UNKNOWN = 'IS_UNKNOWN',
  HAS_ANY_VALUE = 'HAS_ANY_VALUE',
}

export const RadioDateFilterOperationsWithoutSpecificValue = [
  RadioDateFilterOperation.IS_UNKNOWN,
  RadioDateFilterOperation.HAS_ANY_VALUE,
];

// We need to create all the types for typescript to be able to infer the type based on the operation property.

interface IsExactlyDaysAgoOperation {
  operation: RadioDateFilterOperation.IS_EXACTLY_DAYS_AGO;
  value: number;
}

interface IsMoreThanDaysAgoOperation {
  operation: RadioDateFilterOperation.IS_MORE_THAN_DAYS_AGO;
  value: number;
}

interface IsLessThanDaysAgoOperation {
  operation: RadioDateFilterOperation.IS_LESS_THAN_DAYS_AGO;
  value: number;
}

interface IsOnOperation {
  operation: RadioDateFilterOperation.IS_ON;
  value: Date;
}

interface IsAfterOperation {
  operation: RadioDateFilterOperation.IS_AFTER;
  value: Date;
}

interface IsBeforeOperation {
  operation: RadioDateFilterOperation.IS_BEFORE;
  value: Date;
}

interface IsUnknownOperation {
  operation: RadioDateFilterOperation.IS_UNKNOWN;
}

interface HasAnyValueOperation {
  operation: RadioDateFilterOperation.HAS_ANY_VALUE;
}

export type RadioDateFilterValue =
  | IsExactlyDaysAgoOperation
  | IsMoreThanDaysAgoOperation
  | IsLessThanDaysAgoOperation
  | IsOnOperation
  | IsAfterOperation
  | IsBeforeOperation
  | IsUnknownOperation
  | HasAnyValueOperation;

export type RadioDateFilterValueType = RadioDateFilterValue | undefined;
